// extracted by mini-css-extract-plugin
export default {"duration":"duration_duration__RtzXb","durationContent":"duration_durationContent__bydQC"};